import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import CollectionList from "../CollectionList";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardTab } from "../slice";
import { dashboardMenu } from "../../../data";
import { useCollection } from "../Actions/ActionDate/useCollection";
import { avataStyles, svgIconStyle } from "../../DonationView/Cart/styles";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { Avatar, Box } from "@mui/material";
import moment from "moment";
import {
  CollectionStatus,
  CollectionType,
  EntityType,
} from "../../../common/enum";
import { useNavigate } from "react-router-dom";
var nocollections = true;
const CANCELLED_COLLECTION = {
  cancel: CollectionStatus.cancelled,
  collected: CollectionStatus.collected
};

const UpComingCollections = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    allCollectionDetail,
    setMonthStartDate,
    setMonthEndDate,
    setDateState,
  } = useCollection();
  const {
    dashboardInfo: { entityProfileSelect },
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);

  React.useEffect(() => {
    const currentDate = new Date();
    const lastDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      1
    );
    setMonthStartDate(moment(currentDate).format("YYYY-MM-DD"));
    setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
  }, []);
  const havecollecton = allCollectionDetail.filter(collection => collection.collection.status === 'RESERVED')

  return (
    <Grid item>
      <Typography
        fontSize={"24px"}
        fontWeight={600}
        fontFamily={"Sitka Heading"}
        sx={{
          paddingX: {
            xs: "17px",
            sm: "17px",
            md: "17px",
            lg: "0px",
            xl: "0px",
          },
        }}
      >
        {t("upComingCollection")}{" "}
        <Button
          variant="contained"
          disableRipple={true}
          sx={{
            color: "#37773E",
            background: "#E1EFB0",
            fontFamily: "Poppins",
            "&:hover": {
              color: "white",
            },
            float: {
              xs: "right",
              sm: "right",
              md: "right",
              lg: "none",
              xl: "none",
            },
            borderRadius:"4px"
          }}
          onClick={() => {
            navigate(dashboardMenu[2].link);
            // dispatch(setDashboardTab(dashboardMenu[2].title));
          }}
        >
          {t("seeAll")}
        </Button>
      </Typography>
      <Typography
        fontSize={"small"}
        fontFamily={"Poppins"}
        sx={{
          color: "#6E6E6E",
          paddingLeft: {
            xs: "17px",
            sm: "17px",
            md: "17px",
            lg: "0px",
            xl: "0px",
          },
          mb: 1,
        }}
      >
        {t("collectionOfScheduledDonations")}
      </Typography>
      <Stack spacing={1} sx={{ p: 1, maxHeight: "390px", overflow: "hidden", width: 1 }}>
  {allCollectionDetail.length > 0
    ? allCollectionDetail
        .filter(
          (item) =>
            !Object.values(CANCELLED_COLLECTION).includes(item?.collection.status)
        )
        .map((item) => (
          <CollectionList
            item={item}
            t={t}
            key={item.collection.id}
            setDateValue={setDateState}
          />
        ))
    : null
  }

  {(allCollectionDetail.length === 0 || havecollecton.length === 0) && (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        mt: "5%",
      }}
    >
      <Avatar sx={avataStyles}>
        <SvgIconStyle
          src="/static/dashboard/icon-nextdelivery.svg"
          sx={svgIconStyle}
        />
      </Avatar>
      <Box sx={{ paddingLeft: "10px" }}>
        <Typography sx={{ marginTop: "10px" }}>
          {entity?.entityType === EntityType.distributor ||
          entityProfileSelect === EntityType.distributor
            ? t("noUpComingDistributorCollection")
            : t("noUpcomingCollections")}
        </Typography>
      </Box>
    </Box>
  )}
</Stack>
    </Grid>
  );
};

export default UpComingCollections;
